import React from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Grid,
  Text,
  Line,
  Span
} from 'components'
import { GrupoItenHht } from 'services/NGT/ReportsEffectives'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'
import FormatarNumeros from '../../../../../../utils/formatNumbers'

// import { Container } from './styles';
interface ITableContract {
  tableData: GrupoItenHht[]
}

const setJustifyIfHE = (justify: string, he: number) => {
  if (!justify || justify == '') return ''
  if (he && he.toString() != '0') return justify
  return ''
}

const TableSalaryReportContract: React.FC<ITableContract> = ({ tableData }) => {
  const index = tableData.map((data) => data.grupo).indexOf('SubTotal')
  formatTableNumbers(tableData)

  SortTableData(tableData)

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">Mês/Ano</TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="left">Qtd.HHT</TableCellStyled>
              <TableCellStyled align="left">Qtd.HE</TableCellStyled>
              <TableCellStyled align="left">HE%</TableCellStyled>
              <TableCellStyled align="left">Justificativa HE%</TableCellStyled>
              <TableCellStyled align="left">Salário Base </TableCellStyled>
              <TableCellStyled align="left">Total Folha</TableCellStyled>
              <TableCellStyled align="left">Efetivo</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.map(
              (row) =>
                !row.grupo && (
                  <TableRowStyled>
                    <TableCellStyled align="left">{row.mesAno}</TableCellStyled>
                    <TableCellStyled align="left">
                      {row.cdContrato}
                    </TableCellStyled>
                    <TableCellStyled align="left">{row.qtdHht}</TableCellStyled>
                    <TableCellStyled align="left">{row.qtdHe}</TableCellStyled>
                    <TableCellStyled align="left">
                      {row.percentHe}
                    </TableCellStyled>
                    <Grid>
                      <TableCellStyled
                        style={{ backgroundColor: COLORS.headerColor }}
                        align="left"
                      >
                        Justificativa Nº Efetivos
                      </TableCellStyled>
                      <TableCellStyled
                        align="left"
                        style={{ height: 'auto', minHeight: '30px' }}
                      >
                        <div>{row.justificativaNumeroEfetivos ?? ''}</div>
                      </TableCellStyled>
                      <TableCellStyled
                        style={{ backgroundColor: COLORS.headerColor }}
                        align="left"
                      >
                        Justificativa %HE
                      </TableCellStyled>
                      <TableCellStyled
                        align="left"
                        style={{ height: 'auto', minHeight: '30px' }}
                      >
                        <div>{setJustifyIfHE(row?.justifQtdHe, row.qtdHe)}</div>
                      </TableCellStyled>
                      <TableCellStyled
                        style={{ backgroundColor: COLORS.headerColor }}
                        align="left"
                      >
                        Justificativa Vlr Contratada
                      </TableCellStyled>
                      <TableCellStyled
                        align="left"
                        style={{ height: 'auto', minHeight: '30px' }}
                      >
                        <div>{row.justificativaVlrContratada ?? ''}</div>
                      </TableCellStyled>
                    </Grid>
                    <TableCellStyled align="left">
                      {row.salBaseTotal
                        ?.toLocaleString('pt-BR', {
                          currency: 'BRL',
                          style: 'currency'
                        })
                        .toString()}
                    </TableCellStyled>
                    <TableCellStyled align="left">
                      {row.folhaPgtoTotal
                        ?.toLocaleString('pt-BR', {
                          currency: 'BRL',
                          style: 'currency'
                        })
                        .toString()}
                    </TableCellStyled>
                    <TableCellStyled align="left">
                      {row.qtTotalEfetivoSemDemitido}
                    </TableCellStyled>
                  </TableRowStyled>
                )
            )}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <Line background={COLORS.blueFonts} />
      <Grid gridCols="1fr 1fr" gridGap="0.5rem" margin="0">
        <Grid gridCols="1fr" gridGap="0.5rem" margin="1rem 0 0 0">
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="MÊS ANO ANTERIOR: "
            />
            <Span
              color={COLORS.blueFonts}
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text={tableData[index]?.mesAnoAnterior}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total Salário Base: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={tableData[index]?.salBaseTotalAnterior
                ?.toLocaleString('pt-BR', {
                  currency: 'BRL',
                  style: 'currency'
                })
                .toString()}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total Folha: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={tableData[index]?.folhaPgtoTotalAnterior
                ?.toLocaleString('pt-BR', {
                  currency: 'BRL',
                  style: 'currency'
                })
                .toString()}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total HHT: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[index].qtdHhtAnterior)}
            />
          </Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="Total HE: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[index].qtdHeAnterior)}
            />
          </Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="Total Efetivo: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[index].efetivoTotalAnterior)}
            />
          </Text>
          <Text></Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="% HHT x HE:"
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[index]?.percentHeHhtAnterior)}
            />
          </Text>
        </Grid>

        <Grid gridCols="1fr" gridGap="0.5rem" margin="1rem 0 0 0">
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="MÊS/ANO: "
            />
            <Span
              color={COLORS.blueFonts}
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text={tableData[index]?.mesAno}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total Salário Base: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={tableData[index].salBaseTotal
                .toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
                .toString()}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total Folha: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={tableData[index].folhaPgtoTotal
                .toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
                .toString()}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total HHT: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[index].qtdHht)}
            />
          </Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="Total HE: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[index].qtdHe)}
            />
          </Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="Total Efetivo: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[index].qtTotalEfetivoSemDemitido)}
            />
          </Text>
          <Text></Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="% HHT x HE:"
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[index]?.percentHeHht)}
            />
          </Text>
        </Grid>
      </Grid>
    </>
  )

  function SortTableData(tableData) {
    tableData.sort(
      (a, b) =>
        converterStringDate(a.mesAno).getTime() -
        converterStringDate(b.mesAno).getTime()
    )
  }

  function converterStringDate(dateString: string) {
    const parts = dateString.split('/')
    return new Date(parseInt(parts[1]), parseInt(parts[0]) - 1)
  }

  function formatTableNumbers(tableData: GrupoItenHht[]) {
    tableData.map((data) => {
      data.qtdHht = formatarNumero(data.qtdHht) as unknown as number
      data.qtdHe = formatarNumero(data.qtdHe) as unknown as number
      data.percentHe = formatarNumero(data.percentHe) as unknown as number
      data.percentHeHht = formatarNumero(data.percentHeHht) as unknown as number
      data.qtTotalEfetivoSemDemitido = formatarNumero(
        data.qtTotalEfetivoSemDemitido
      ) as unknown as number

      data.qtdHhtAnterior = formatarNumero(
        data.qtdHhtAnterior
      ) as unknown as number
      data.qtdHeAnterior = formatarNumero(
        data.qtdHeAnterior
      ) as unknown as number
      data.percentHeAnterior = formatarNumero(
        data.percentHeAnterior
      ) as unknown as number
      data.percentHeHhtAnterior = formatarNumero(
        data.percentHeHhtAnterior
      ) as unknown as number
      data.efetivoTotalAnterior = formatarNumero(
        data.efetivoTotalAnterior
      ) as unknown as number
    })
  }
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero)
}

export default TableSalaryReportContract
